import { Injectable } from '@angular/core';

const TOKEN_KEY = 'CesarAuthToken';

/**
 * Token storage for the auth (service on the browser)
 */

@Injectable({
  providedIn: 'root',
})
export class TokenStorage {
  /**
   * Constructeur.
   */
  constructor() {}

  /**
   * Logs out the user
   */
  signOut() {
    sessionStorage.clear();
  }

  /**
   * Saves the auth token in the SessionStorage
   * @param token Auth token instance.
   */
  public saveToken(token: string) {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.setItem(TOKEN_KEY, token);
  }

  /**
   * Gives the auth token back from the session Storage.
   * @returns :Auth token instance.
   */
  public getToken(): string | null {
    const token = sessionStorage.getItem(TOKEN_KEY);
    return token;
  }
}
